import React from "react";

export default function TOS(){
    return (
        <>
            <a className="text-dark" href='https://www.crlcorp.com/terms-of-use/' target="_blank">
                <strong>Terms of Use</strong>
            </a>
        </>
    )
}
